import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactForm from "../common/components/ReactForm";
import Select from "../common/components/Select";
import useNetwork from "../common/hooks/networkHook";
import { ReactNodeDialog } from "../common/utils/dialogUtlities";
import { dynamicSort } from "../common/utils/tableUtilities";
import { useContactLists } from "../reducers/contactSlice";

const ContactListSelector = ({ kind, show, onClose, addContacts }) => {
    const { t } = useTranslation();
    const network = useNetwork();
    const contactLists = useContactLists();
    const [selectedContactList, setSelectedContactList] = useState();
    const [saving, setSaving] = useState(false);
    const validationRef = useRef();

    const doClose = useCallback(() => {
        setSaving(false);
        setSelectedContactList();
        onClose?.();
    }, [onClose]);
    
    const selectContacts = useCallback( async () => {
        if (validationRef.current?.checkValidity()) {
            setSaving(true);
            let response = await network.fetchData('/api/v1/contacts/' + encodeURIComponent(selectedContactList));
            if (response.ok) {
                try {
                    const data = await response.json();
                    addContacts(data);
                    doClose();
                } catch {
                    doClose();
                }
            } else {
                doClose();
            }
        }
    }, [doClose, addContacts, network, selectedContactList]);

    const listsToRender = contactLists.filter(list => !kind || list[kind]);
    listsToRender.sort(dynamicSort(['name']));

    return <ReactNodeDialog showModal={show} title={t('contactList', { count: 100 })} size="lg" invalid={saving} onSave={selectContacts} onClose={doClose}>
        <ReactForm ref={validationRef}>
            <Select placeholder={t('contactList', { count: 1 })} value={selectedContactList} onChange={setSelectedContactList} options={listsToRender} labelField="name" valueField="id"></Select>
        </ReactForm>
    </ReactNodeDialog>
}

export default ContactListSelector;